import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useParams } from "react-router";
import apiHelper from "../../../utils/apiHelper";
import {
  DocumentEntityTypesEnum,
  DocumentService,
  DocumentTypesEnum,
  LeaseAgreementService,
  LeaseAgreementStatusTypesEnum,
  LeaseApplicationService,
  LeaseApplicationStatusTypesEnum,
  OrganizationService,
  TemplateService,
  TemplateVM,
  TenantService,
  TenantVM,
} from "@propertelligent/client-api";
import "./landlordTenantOnboard.css";
import ProspectTenantCard from "../../../newComponents/listings/listing-cards/prospect-tenant";
import EmptyState from "../../../newComponents/emptystate";
import { GetImages } from "../../../utils/GetImages";
import StepProgress from "../../TenantOnboard/component/StepProgress/StepProgress";
import BoardingReview from "../../TenantOnboard/RenderSteps/BoardingReview";
import StatusHeader from "../../TenantOnboard/component/StatusHeader/StatusHeader";
import { Offcanvas } from "react-bootstrap";
import PostPayment from "./component/postpayment/PostPayment";
import { UserLoginData } from "../../common/charts/Enums";
import SendReminder from "../SendReminder";
import RejectedScreen from "../rejected";
import ApprovedScreen from "../approved";
import {
  Accordion,
  AccordionSection,
} from "../../../newComponents/card/accordion";
import SimpleButton from "../../../newComponents/buttons/Simple-button";
import LeaseAgreementSettings from "../LeaseAgreement/LeaseAgreementSettings";
import {
  checkEmptyFieldsFunc,
  handleDownloadPdf,
  handleGenerateAndUploadPdf,
} from "../../../utils/validateHelper";
import PrintLayout from "../../generatePdfDocument/printLayout";
import { useReactToPrint } from "react-to-print";
import ShowLeaseAgreement from "../LeaseAgreement/ShowLeaseAgreement";
import { getLeaseAgreementSteps, utcDateFormat } from "../../../utils/helper";
import { useError } from "../../../utils/context/ErrorContext";
import { PubSub, TopicsEnum } from "../../../utils/pubsub";
import MoveInAndOutContentBlocks from "../common/MoveInAndOutContentBlocks";
import OrganizationNameHeader from "../../common/OrganizationNameHeader/OrganizationNameHeader";
import { TextCss } from "../../GlobalCss/TextCss";
import SimpleOutlineButton from "../../../newComponents/buttons/Simple-Outline-button";
import { ConfirmationPopup } from "../../../newComponents/confirmation-popup/confirmation-popup-demo";
import LoaderOverlay from "../../common/LoaderOverlay";
import SimpleSpinner from "../../loader";
interface AccordionState {
  leaseapplication: boolean;
  leaseagreement: boolean;
  basicDetailsComplete: boolean;
}

const initialAccordionState: AccordionState = {
  leaseapplication: true,
  leaseagreement: false,
  basicDetailsComplete: false,
};
const LandlordTenantOnboard = () => {
  const { id } = useParams();
  const contentRef = useRef();
  const agreementRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } =
    useError();
  const [accordionState, setAccordionState] = useState<AccordionState>(
    initialAccordionState,
  );
  const [selectOption, setSelectOption] = useState("Approved");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [leaseApplication, setLeaseApplication] = useState<any>();
  const [showSignAgreeConfirm, setShowSignAgreeConfirm] = useState(false);
  // const [templateData, setTemplateData] = useState<TemplateVM>()
  const [templateData, setTemplateData] = useState<any>();
  const [tenantData, setTenantData] = useState<TenantVM>();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [showModel, setShowModel] = useState(false);
  const [isPrint, setISPrint] = useState(false);
  const [previewLeaseAgreement, setPreviewLeaseAgreement] = useState(false);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [selectedView, setSelectedView] = useState<string>("leaseapplication");
  const [isSigningAgreement, setIsSigningAgreement] = useState(false);
  const [OrgDetail, setOrgDetail] = useState<any>();
  const [selectedTemplateid, setSelectedTemplateid] = useState();
  const [postLeaseAgreement, setPostLeaseAgreement] = useState<any>({
    tenantId: leaseApplication?.tenantId,
    leaseAgreementId: leaseApplication?.leaseAgreementId,
    unitId: leaseApplication?.unitId,
    templateId: leaseApplication?.templateId,
    dataAttributes: {},
    tenantSignature: { fullName: "", signedDateTime: new Date() },
    landlordSignature: { fullName: "", signedDateTime: new Date() },
  });
  useEffect(() => {
    if (!leaseApplication) return;

    setPostLeaseAgreement((prev) => ({
      ...prev,
      tenantId: leaseApplication.tenantId || prev.tenantId,
      unitId: leaseApplication.unitId || prev.unitId,
      templateId: leaseApplication.templateId || prev.templateId,
      leaseAgreementId:
        leaseApplication.leaseAgreementId || prev.leaseAgreementId,
    }));
  }, [leaseApplication]);

  useEffect(() => {
    const orgId = sessionStorage.getItem(UserLoginData.organization_id);
    if (orgId) {
      apiHelper(
        OrganizationService.getApiOrganizationHeaderInfo,
        { showNotification: false },
        Number(orgId),
      )
        .then((res) => {
          setOrgDetail(res?.data?.success);
        })
        .catch((error) => {});
    }
  }, []);
  const [interalTenant, setInteralTenant] = useState("");
  const [noteTenant, setNoteTenant] = useState("");
  // ReceivablesPostPayment

  const getLeaseApplication = async () => {
    if (id) {
      setLoading(true);
      await apiHelper(
        LeaseApplicationService.getApiLeaseApplication1,
        { showNotification: false },
        id,
      )
        .then((response: any) => {
          if (response?.data?.success) {
            setLeaseApplication(response?.data?.success);
            apiHelper(
              TemplateService.getApiTemplate,
              { showNotification: false },
              response?.data?.success?.templateId,
            )
              .then((resp) => {
                setTemplateData(resp?.data?.success);
              })
              .catch((err) => {});

            apiHelper(
              TenantService.getApiTenant1,
              { showNotification: false },
              Number(response?.data?.success?.tenantId),
            )
              .then((response) => {
                setTenantData(response?.data?.success);
              })
              .finally(() => {
                setLoading(false);
              });
          } else {
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    getLeaseApplication();
  }, [
    leaseApplication?.leaseApplicationStatusTypeId,
    leaseApplication?.leaseAgreementStatusTypeId,
  ]);

  useEffect(() => {
    const leaseStatus = leaseApplication?.leaseApplicationStatusTypeId;
    const agreementStatus = leaseApplication?.leaseAgreementStatusTypeId; // ✅ consistent lowercase

    if (!leaseStatus && !agreementStatus) return;

    if (leaseStatus === LeaseApplicationStatusTypesEnum.PaymentPending)
      setStatus("paymentPending");
    else if (leaseStatus === LeaseApplicationStatusTypesEnum.Submitted)
      setStatus("submitted");
    else if (leaseStatus === LeaseApplicationStatusTypesEnum.InProgress)
      setStatus("inProgress");
    else if (leaseStatus === LeaseApplicationStatusTypesEnum.InReview)
      setStatus("review");
    else if (leaseStatus === LeaseApplicationStatusTypesEnum.Closed)
      setStatus("close");
    else if (leaseStatus === LeaseApplicationStatusTypesEnum.Rejected)
      setStatus("Reject");
    else if (
      agreementStatus === LeaseAgreementStatusTypesEnum.PendingTenantSignature
    ) {
      setStatus("tenantSignaturePending");
    } else if (agreementStatus === LeaseAgreementStatusTypesEnum.Signed) {
      setStatus("movein");
    } else if (
      agreementStatus === LeaseAgreementStatusTypesEnum.PendingPayment
    ) {
      setStatus("leasePaymentPending");
    } else if (
      agreementStatus ===
        LeaseAgreementStatusTypesEnum.PendingLandlordSignature &&
      leaseStatus === LeaseApplicationStatusTypesEnum.Approved
    ) {
      setStatus("landlordSignaturePending");
    } else if (leaseStatus === LeaseApplicationStatusTypesEnum.Approved) {
      setStatus("");
      setSelectedView("leaseagreement");
      setAccordionState({
        leaseapplication: false,
        leaseagreement: true,
        basicDetailsComplete: false,
      });
    } else {
      setStatus("unknown");
    }
  }, [
    leaseApplication?.leaseApplicationStatusTypeId,
    leaseApplication?.leaseAgreementStatusTypeId,
  ]);
  useEffect(() => {
    if (!leaseApplication) return;

    const leaseStatus = leaseApplication.leaseApplicationStatusTypeId;
    const agreementStatus = leaseApplication.leaseAgreementStatusTypeId;

    const showLeaseApplication =
      leaseStatus === LeaseApplicationStatusTypesEnum.InProgress ||
      leaseStatus === LeaseApplicationStatusTypesEnum.Submitted ||
      leaseStatus === LeaseApplicationStatusTypesEnum.InReview ||
      leaseStatus === LeaseApplicationStatusTypesEnum.Closed ||
      leaseStatus === LeaseApplicationStatusTypesEnum.PaymentPending;

    const showLeaseAgreement =
      (leaseStatus === LeaseApplicationStatusTypesEnum.Approved &&
        (agreementStatus ===
          LeaseAgreementStatusTypesEnum.PendingTenantSignature ||
          agreementStatus ===
            LeaseAgreementStatusTypesEnum.PendingLandlordSignature ||
          agreementStatus === LeaseAgreementStatusTypesEnum.PendingPayment)) ||
      agreementStatus === LeaseAgreementStatusTypesEnum.Signed;

    if (showLeaseApplication) {
      setAccordionState({
        leaseapplication: true,
        leaseagreement: false,
        basicDetailsComplete: false,
      });
      setSelectedView("leaseapplication");
    }

    if (
      showLeaseAgreement &&
      agreementStatus !== LeaseAgreementStatusTypesEnum.Signed
    ) {
      setAccordionState({
        leaseapplication: false,
        leaseagreement: true,
        basicDetailsComplete: true,
      });
      setSelectedView("leaseagreement");
    }

    if (agreementStatus === LeaseAgreementStatusTypesEnum.Signed) {
      setAccordionState({
        leaseapplication: false,
        leaseagreement: false,
        basicDetailsComplete: true,
      });
      setSelectedView("movein");
    }
  }, [
    leaseApplication?.leaseApplicationStatusTypeId,
    leaseApplication?.leaseAgreementStatusTypeId,
  ]);
  const handleActionClick = (actionLabel) => {
    if (actionLabel === "Post Payment") {
      setSelectOption("PostPayment");
      setShowModel(true);
    } else if (actionLabel === "Reject") {
      setSelectOption("Reject");
      setShowModel(true);
    } else if (actionLabel === "Approve") {
      setSelectOption("Approve");
      setShowModel(true);
    } else if (actionLabel == "Send Reminder") {
      setShowModel(true);
      setSelectOption("Reminder");
    } else if (actionLabel === "Sign Agreement") {
      const element = document.getElementById("signature-section");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
      // setStatus("submitted");
    }
  };

  const commonProps = {
    IsFooter: true,
    dataHookState: {
      rows: [leaseApplication],
      loading: undefined,
      hasMore: undefined,
      rowCount: undefined,
      fetchData: getLeaseApplication,
      currentPage: undefined,
      aggregateValues: undefined,
    },
  };

  const leaseAgreementStepLabels = [
    "Send Agreement",
    "Tenant Signature",
    "Payments",
    "Landlord Signature",
  ];

  const getLeaseAgreementSteps = (statusId?: number | string) => {
    const total = leaseAgreementStepLabels.length;
    const n = Number(statusId) || 0;
    const completedCount = Math.max(0, Math.min(total, n));
    return leaseAgreementStepLabels.map((label, idx) => ({
      label,
      completed: idx < completedCount,
    }));
  };

  // useMemo so steps recompute only when status changes
  const leaseAgreementSteps = useMemo(
    () =>
      getLeaseAgreementSteps(
        postLeaseAgreement?.leaseAgreementStatusTypeId ??
          leaseApplication?.leaseAgreementStatusTypeId,
      ),
    [
      postLeaseAgreement?.leaseAgreementStatusTypeId,
      leaseApplication?.leaseAgreementStatusTypeId,
    ],
  );

  const leaseAgreementCompletedCount = leaseAgreementSteps.filter(
    (s) => s.completed,
  ).length;
  const leaseAgreementProgress =
    leaseAgreementSteps.length > 0
      ? Math.round(
          (leaseAgreementCompletedCount / leaseAgreementSteps.length) * 100,
        )
      : 0;

  const safeParse = (val?: string | null) => {
    try {
      if (val == null) return null;
      if (typeof val === "object") return val;
      return JSON.parse(val);
    } catch {
      return null;
    }
  };

  const isStepCompleted = (stepKey: string): boolean => {
    if (!leaseApplication?.dataSections) return false;
    if (stepKey === "ApplicationFees") {
      return Boolean(
        safeParse(leaseApplication?.dataSections?.ApplicationFees)?.isPaid,
      );
    }
    const rawData =
      leaseApplication.dataSections[
        stepKey as keyof typeof leaseApplication.dataSections
      ];
    const stepData = safeParse(rawData as any);
    if (!stepData) return false;
    if (Array.isArray(stepData)) {
      return stepData.length > 0;
    }
    if (typeof stepData === "object") {
      return Object.values(stepData).some(
        (value) => value !== "" && value !== undefined && value !== null,
      );
    }
    return false;
  };

  const stepLabels: Record<string, string> = {
    CurrentAddress: "Current Address",
    RentIncomeCheck: "Rent Pay Information",
    CreditCheck: "Credit Check",
    EmploymentHistory: "Employment History",
    References: "References",
    Questionnaires: "Questionnaire",
    Signature: "Signature",
    ApplicationFees: "Application Fees",
  };

  const templateHas = new Set(
    templateData?.leaseApplicationTemplateSections
      ? Object.keys(templateData?.leaseApplicationTemplateSections)
      : [],
  );

  const leaseApplicationSteps = Object.keys(stepLabels)
    .filter((stepKey) => templateHas?.has(stepKey)) // include only what template defines
    .map((stepKey) => ({
      label: stepLabels[stepKey] ?? stepKey,
      completed: isStepCompleted(stepKey),
    }));

  const completedCount = leaseApplicationSteps?.filter(
    (s) => s.completed,
  ).length;
  const totalSteps = leaseApplicationSteps.length;
  const progress =
    totalSteps > 0 ? Math.round((completedCount / totalSteps) * 100) : 0;

  const isEmpty =
    !leaseApplication?.dataSections ||
    Object.keys(leaseApplication.dataSections).length === 0;

  const renderLeaseAgreementSettings = () => (
    <LeaseAgreementSettings
      userData={tenantData}
      setIsPrint={setISPrint}
      selectedTemplateid={selectedTemplateid}
      setSelectedTemplateid={setSelectedTemplateid}
      setPostLeaseAgreement={setPostLeaseAgreement}
      postLeaseAgreement={postLeaseAgreement}
      setPreviewLeaseAgreement={undefined}
      // formData={formData} setFormData={setFormData}
      leaseApplicationId={id}
    />
  );

  const toggleAccordion = useCallback(
    (section: keyof AccordionState) => {
      if (
        section === "leaseagreement" &&
        leaseApplication?.leaseApplicationStatusTypeId !==
          LeaseApplicationStatusTypesEnum.Approved
      ) {
        return;
      }

      setAccordionState((prev) => {
        const newState = {
          ...prev,
          leaseapplication:
            section === "leaseapplication" ? !prev.leaseapplication : false,
          leaseagreement:
            section === "leaseagreement" ? !prev.leaseagreement : false,
        };
        if (newState[section]) {
          setSelectedView(section);
        }
        return newState;
      });
    },
    [leaseApplication?.leaseApplicationStatusTypeId],
  );
  const getStatusTypeId = (status) => {
    switch (status) {
      case "Approve":
        return LeaseApplicationStatusTypesEnum.Approved;
      case "Reject":
        return LeaseApplicationStatusTypesEnum.Rejected;
      case "Closed":
        return LeaseApplicationStatusTypesEnum.Closed;
      default:
        break;
    }
  };
  const handleSubmit = (approve) => {
    setShowConfirmation(false);

    const dataToSend = {
      leaseApplicationStatusTypeId: getStatusTypeId(selectOption),
      internalNotes: interalTenant,
      tenantNotes: noteTenant,
    };

    apiHelper(
      LeaseApplicationService.putApiLeaseApplicationReivew,
      {
        successMessage: `Applicaton ${selectOption} successfully`,
        failureMessage: `Applicaton ${selectOption} unable`,
        showNotification: true,
      },
      id,
      dataToSend,
    )
      .then((response) => {
        if (response?.data?.success) {
          setShowModel(false);
          getLeaseApplication();

          PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
        }
      })
      .catch((error) => {});
  };

  const handleUploadDocument = async (
    pdfBlob,
    docType = DocumentTypesEnum.LeaseApplication,
  ) => {
    const fileName =
      docType === DocumentTypesEnum.LeaseAgreement
        ? "Lease_Agreement.pdf"
        : "Lease_Application.pdf";
    const pdfFile = new File([pdfBlob], fileName, { type: "application/pdf" });
    const imgData = {
      EntityId: Number(id),
      EntityTypeId: DocumentEntityTypesEnum.Tenant,
      DocumentTypeId: docType,
      IsMain: false,
      Document: pdfFile,
      FileName: fileName,
    };
    await apiHelper(
      DocumentService.postApiDocument,
      { showNotification: false },
      imgData,
    )
      .then((res) => {})
      .catch((err) => {});
  };
  const onClose = () => {
    setInteralTenant("");
    setNoteTenant("");
    setShowConfirmation(false);
  };

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(
      TopicsEnum.RefreshLeaseData.toString(),
      () => {
        getLeaseApplication();
      },
    );

    return () => unsubscribe();
  }, []);
  const allSectionsApproved = useMemo(() => {
    if (
      !leaseApplication?.reviewSections ||
      !templateData?.leaseApplicationTemplateSections
    ) {
      return false;
    }

    const requiredSections = Object.keys(
      templateData.leaseApplicationTemplateSections,
    ).filter(
      (section) => section !== "Signature" && section !== "ApplicationFees",
    );
    return requiredSections.every(
      (section) =>
        leaseApplication.reviewSections?.[section]?.approved === true,
    );
  }, [
    leaseApplication?.reviewSections,
    templateData?.leaseApplicationTemplateSections,
  ]);

  const resendInvite = () => {
    apiHelper(
      LeaseApplicationService.putApiLeaseApplicationResendInvite,
      { successMessage: "Invite Sent Successfully", showNotification: true },
      id,
    )
      .then((res) => {})
      .catch((err) => {});
  };
  const SignLeaseAgreement = async () => {
    let leaseData = {
      fullName: postLeaseAgreement?.landlordSignature?.fullName,
      signedDateTime: postLeaseAgreement?.landlordSignature?.signedDateTime
        ? utcDateFormat(postLeaseAgreement.landlordSignature.signedDateTime)
        : utcDateFormat(new Date().toISOString()),
    };

    if (
      checkEmptyFieldsFunc(
        leaseData,
        clearErrors,
        errors,
        errorMessages,
        setErrors,
        setErrorMessages,
        undefined,
      )
    ) {
      setErrors({ ...errors, fullName: true });
      setErrorMessages({ ...errorMessages, fullName: "Full Name is required" });
      return;
    }

    setIsSigningAgreement(true);

    try {
      const response = await apiHelper(
        LeaseAgreementService.putApiLeaseAgreementLandlordSignature,
        {
          showNotification: true,
          successMessage: "Lease Agreement signed successfully",
          failureMessage: "Unable to sign Lease Agreement",
        },
        postLeaseAgreement?.leaseAgreementId ||
          leaseApplication?.leaseAgreementId,
        leaseData as any,
      );

      if (response?.data?.success) {
        setPostLeaseAgreement((prev) => ({
          ...prev,
          landlordSignature: {
            ...prev.landlordSignature,
            ...leaseData,
            ...(typeof response?.data?.success === "object"
              ? response.data.success
              : {}),
          },
        }));

        setISPrint(true);
        await new Promise((resolve) => requestAnimationFrame(resolve));

        if (!agreementRef.current) {
          console.error("Agreement ref not found!");
          setISPrint(false);
          return;
        }

        await handleGenerateAndUploadPdf(
          setISPrint,
          agreementRef,
          async (blob) => {
            const file = new File(
              [blob],
              `LeaseAgreement-${tenantData?.firstName || "Signed"}.pdf`,
              { type: "application/pdf" },
            );
            const uploadData = {
              EntityTypeId: DocumentEntityTypesEnum.Tenant,
              EntityId: Number(leaseApplication?.tenantId),
              DocumentTypeId: DocumentTypesEnum.LeaseAgreement,
              IsMain: false,
              FileName: file.name,
              Document: file,
            };
            await apiHelper(
              DocumentService.postApiDocument,
              { showNotification: false },
              uploadData,
            );
          },
        );

        await getLeaseApplication();
        PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null);
        setISPrint(false);
      }
    } catch (err) {
      console.error("API error for lease agreement:", err);
      setISPrint(false);
    } finally {
      setIsSigningAgreement(false);
    }
  };

  return (
    <>
      {loading ? (
        <SimpleSpinner isFullPage={true} />
      ) : (
        <div className="tenantOnboardContainer">
          <div className="tennatOnboardHeader">
            <ProspectTenantCard
              Id="ProspectTenant"
              {...commonProps}
              className={undefined}
              isLink={false}
            />
            <div className="px-4">
              <StatusHeader
                role="landlord"
                status={status}
                onActionClick={handleActionClick}
                disableApprove={
                  leaseApplication?.leaseApplicationStatusTypeId !==
                    LeaseApplicationStatusTypesEnum.Submitted &&
                  leaseApplication?.leaseApplicationStatusTypeId !==
                    LeaseApplicationStatusTypesEnum.InReview
                }
              />
            </div>
          </div>
          <div className="onboardMainSection">
            <div className="tennatOnboardSection">
              <div className="tenantOnboardSidebar">
                <div className="sidebar-panel">
                  <p className="heading black">Invite Tenant</p>
                  <Accordion>
                    <AccordionSection
                      title="Lease Application"
                      isDisabled={
                        leaseApplication?.leaseApplicationStatusTypeId ===
                        LeaseApplicationStatusTypesEnum.Invited
                      }
                      isOpen={
                        leaseApplication?.leaseApplicationStatusTypeId ===
                        LeaseApplicationStatusTypesEnum.Invited
                          ? false
                          : accordionState.leaseapplication
                      }
                      onToggle={() => toggleAccordion("leaseapplication")}
                    >
                      <StepProgress
                        title=""
                        steps={leaseApplicationSteps}
                        progress={progress}
                      />
                      <div className="sidebar-panel__actions">
                        <SimpleOutlineButton
                          isDisabled={
                            leaseApplication?.leaseApplicationStatusTypeId ===
                              LeaseApplicationStatusTypesEnum.Closed ||
                            leaseApplication?.leaseApplicationStatusTypeId ===
                              LeaseApplicationStatusTypesEnum.Rejected ||
                            leaseApplication?.leaseApplicationStatusTypeId ===
                              LeaseApplicationStatusTypesEnum.Withdrawn
                          }
                          label={"Close"}
                          onClick={() => {
                            setShowModel(true);
                            setSelectOption("Closed");
                          }}
                        />
                        <SimpleOutlineButton
                          label="Print"
                          onClick={() => {
                            setISPrint(true);
                            setTimeout(() => {
                              reactToPrintFn();
                              setISPrint(false);
                            });
                          }}
                        />
                        <SimpleOutlineButton
                          label="Export"
                          onClick={() => {
                            handleDownloadPdf(
                              setISPrint,
                              contentRef,
                              `LeaseApplication-${tenantData?.firstName} ${tenantData?.lastName}.pdf`,
                            );
                          }}
                        />
                      </div>
                    </AccordionSection>
                  </Accordion>
                  <Accordion>
                    <AccordionSection
                      title="Lease Agreement"
                      // isDisabled={!accordionState.leaseagreement}
                      isDisabled={
                        leaseApplication?.leaseApplicationStatusTypeId !==
                        LeaseApplicationStatusTypesEnum.Approved
                      }
                      isOpen={accordionState.leaseagreement}
                      onToggle={() => toggleAccordion("leaseagreement")}
                    >
                      <StepProgress
                        title=""
                        steps={leaseAgreementSteps}
                        progress={leaseAgreementProgress}
                      />
                    </AccordionSection>
                  </Accordion>
                  <div
                    className={`border-top pt-1 ${leaseApplication?.leaseAgreementStatusTypeId === LeaseAgreementStatusTypesEnum.Signed ? "cursor-pointer" : "pe-none opacity-50"}`}
                    onClick={() => {
                      if (
                        leaseApplication?.leaseAgreementStatusTypeId ===
                        LeaseAgreementStatusTypesEnum.Signed
                      ) {
                        setSelectedView("movein");
                        setAccordionState({
                          leaseapplication: false,
                          leaseagreement: false,
                          basicDetailsComplete: true,
                        });
                      }
                    }}
                  >
                    <p
                      className={
                        leaseApplication?.leaseAgreementStatusTypeId ===
                        LeaseAgreementStatusTypesEnum.Signed
                          ? TextCss.black.heading_700_16
                          : TextCss.grey_neutral.sub_Heading_400_16
                      }
                    >
                      Move In
                    </p>
                  </div>{" "}
                </div>
              </div>
              <div className="tenantOnboardContent">
                <div
                  data-theme={isPrint ? "light" : undefined}
                  className="testonboard"
                  ref={contentRef}
                >
                  {/* Header conditionally rendered handled in LeaseAgreementContainer */}
                  {isEmpty ? (
                    <EmptyState
                      heading={`Invite sent to ${tenantData?.firstName}`}
                      bodytext={`${tenantData?.firstName} yet to fill lease application details. You’ll be able to see once it is filled`}
                      icon={GetImages.InviteSent}
                      buttonLabel={"Resend Invite"}
                      onButtonClick={resendInvite}
                      isBorder={false}
                    />
                  ) : selectedView === "leaseapplication" ? (
                    <div className={isPrint ? "common_basic_card" : ""}>
                      {isPrint && (
                        <div className="mb-2">
                          <OrganizationNameHeader
                            OrgName={OrgDetail?.name}
                            SubHeaderName={"Lease Application"}
                            OrgImg={
                              OrgDetail?.logoImageBase64 !== ""
                                ? `data:image/*;base64,${OrgDetail?.logoImageBase64}`
                                : null
                            }
                          />
                        </div>
                      )}
                      <BoardingReview
                        editable={false}
                        leaseApplicationId={Number(id)}
                        isEditClick={undefined}
                        postData={undefined}
                        formData={undefined}
                        setFormData={undefined}
                        steps={undefined}
                        getTenantsData={undefined}
                        isPreview={false}
                        landlord={isPrint ? false : true}
                        // leaseApplicationStatus={leaseApplication?.leaseApplicationStatusTypeId}
                      />
                    </div>
                  ) : selectedView === "movein" && !isPrint ? (
                    <MoveInAndOutContentBlocks
                      leaseApplicationId={id}
                      tenantData={tenantData}
                      isMoveOut={false}
                      show={true}
                      setCurrentStep={setCurrentStepIndex}
                    />
                  ) : (selectedView === "leaseagreement" ||
                      (selectedView === "movein" && isPrint)) &&
                    (leaseApplication?.leaseApplicationStatusTypeId ===
                      LeaseApplicationStatusTypesEnum.Approved ||
                      leaseApplication?.leaseAgreementStatusTypeId ===
                        LeaseAgreementStatusTypesEnum.Signed) &&
                    (leaseApplication?.leaseAgreementStatusTypeId ===
                      LeaseAgreementStatusTypesEnum.PendingTenantSignature ||
                      leaseApplication?.leaseAgreementStatusTypeId ===
                        LeaseAgreementStatusTypesEnum.PendingLandlordSignature ||
                      leaseApplication?.leaseAgreementStatusTypeId ===
                        LeaseAgreementStatusTypesEnum.Signed ||
                      leaseApplication?.leaseAgreementStatusTypeId ===
                        LeaseAgreementStatusTypesEnum.PendingPayment) ? (
                    <div
                      data-theme={isPrint ? "light" : undefined}
                      className="LeaseAgreementContainer borderWithBorderRadious py-3"
                      ref={agreementRef}
                    >
                      {isPrint && (
                        <div className="d-flex flex-column gap-3 mb-3">
                          <div className="BackgroundWhite borderWithBorderRadious">
                            <OrganizationNameHeader
                              OrgName={OrgDetail?.name}
                              OrgImg={
                                OrgDetail?.logoImageBase64 !== ""
                                  ? `data:image/*;base64,${OrgDetail?.logoImageBase64}`
                                  : null
                              }
                              SubHeaderName={"Lease Agreement"}
                              element={<></>}
                            />
                          </div>
                        </div>
                      )}
                      <ShowLeaseAgreement
                        leaseApplicationId={id}
                        isPreview={false}
                        userData={tenantData}
                        selectedTemplateid={selectedTemplateid}
                        postLeaseAgreement={postLeaseAgreement}
                        setPostLeaseAgreement={setPostLeaseAgreement}
                        onClick={() => setShowSignAgreeConfirm(true)}
                        onCancel={() => setPreviewLeaseAgreement(false)}
                        role="landlord"
                        buttonName=""
                        selectedTemplates={undefined}
                        showHeader={false}
                        isPrint={isPrint}
                      />
                    </div>
                  ) : (
                    renderLeaseAgreementSettings()
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Offcanvas
        className="offcanvas serviceRequestForm"
        show={showModel}
        onHide={() => setShowModel(false)}
        placement={"end"}
        scroll={true}
      >
        <Offcanvas.Header className="canvasHeader" closeButton>
          <Offcanvas.Title>
            {selectOption == "PostPayment"
              ? "Post Payment"
              : `${selectOption} Application`}{" "}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {selectOption == "Approve" ? (
            <ApprovedScreen
              setShowModel={setShowModel}
              status={LeaseApplicationStatusTypesEnum.Approved}
              interalTenant={interalTenant}
              setInteralTenant={setInteralTenant}
              noteTenant={noteTenant}
              setNoteTenant={setNoteTenant}
              setShowConfirmation={setShowConfirmation}
            />
          ) : selectOption === "Reject" ? (
            <RejectedScreen
              setShowModel={setShowModel}
              interalTenant={interalTenant}
              setInteralTenant={setInteralTenant}
              noteTenant={noteTenant}
              setNoteTenant={setNoteTenant}
              setShowConfirmation={setShowConfirmation}
            />
          ) : selectOption === "Closed" ? (
            <ApprovedScreen
              setShowModel={setShowModel}
              status={LeaseApplicationStatusTypesEnum.Closed}
              interalTenant={interalTenant}
              setInteralTenant={setInteralTenant}
              noteTenant={noteTenant}
              setNoteTenant={setNoteTenant}
              setShowConfirmation={setShowConfirmation}
            />
          ) : selectOption === "Reminder" ? (
            <SendReminder />
          ) : selectOption == "PostPayment" ? (
            <PostPayment
              data={{
                firstName: tenantData?.firstName,
                lastName: tenantData?.lastName,
                fullName: tenantData?.fullName,
                amount:
                  templateData?.leaseApplicationTemplateSections
                    ?.ApplicationFees?.fee,
              }}
              tenantId={leaseApplication.tenantId}
              setShowModel={setShowModel}
              feestype={
                leaseApplication?.leaseAgreementStatusTypeId ==
                LeaseAgreementStatusTypesEnum.PendingPayment
                  ? "Agreement Fees"
                  : "Application fees"
              }
              payDueAccountId={
                leaseApplication?.leaseAgreementStatusTypeId ==
                LeaseAgreementStatusTypesEnum.PendingPayment
                  ? postLeaseAgreement?.paymentDueAccountIds
                  : leaseApplication?.paymentDueAccountIds
              }
            />
          ) : (
            <p>Unknown status.</p>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {showConfirmation && (
        <ConfirmationPopup
          isOpen={true}
          title={
            selectOption == "Approve"
              ? "Approve Application"
              : selectOption == "Rejected"
                ? "Reject Application"
                : "Close Application"
          }
          message={`Are you sure you want to ${
            selectOption == "Approve"
              ? "approve"
              : selectOption == "Rejected"
                ? "reject"
                : "close"
          } ${leaseApplication?.firstName} Application?`}
          primaryButtonLabel="No"
          secondaryButtonLabel="Yes"
          onPrimaryAction={onClose}
          onSecondaryAction={() => {
            if (selectOption == "Approve") {
              handleSubmit("approve");
              handleGenerateAndUploadPdf(
                setISPrint,
                contentRef,
                handleUploadDocument,
              );
            } else if (selectOption == "Reject") {
              handleSubmit("Rejected");
            } else {
              handleSubmit("Close");
            }
          }}
          onClose={onClose}
          isPrimaryAction={false}
          isPrimaryDestructive={false}
        />
      )}

      {showSignAgreeConfirm && (
        <ConfirmationPopup
          isOpen={true}
          title="Confirm Signature"
          message="Are you sure you want to Sign Agreement?"
          primaryButtonLabel="No"
          secondaryButtonLabel="Yes"
          onPrimaryAction={() => setShowSignAgreeConfirm(false)}
          onSecondaryAction={() => {
            setShowSignAgreeConfirm(false);
            SignLeaseAgreement(); // <-- your function will be called here
          }}
          onClose={() => setShowSignAgreeConfirm(false)}
          isPrimaryAction={false}
          isPrimaryDestructive={false}
        />
      )}

      {isSigningAgreement && (
        <LoaderOverlay message="Finalizing your signature..." />
      )}
    </>
  );
};

export default LandlordTenantOnboard;
